export const PackPickEndpoints = {
  GET_STATUS_QUEUES: '/api/admin/pack-pick/status-queues',
  GET_STATIONS: '/api/admin/pack-pick/stations',
  GET_ORDER_DETAILS: (orderNo: string) => `/api/admin/pack-pick/orders/${orderNo}`,
  START_PICK: (orderNo: string) => `/api/admin/pack-pick/orders/${orderNo}/pick`,
  START_PACK: (orderNo: string) => `/api/admin/pack-pick/orders/${orderNo}/pack/start`,
  COMPLETE_PACK: (orderNo: string) => `/api/admin/pack-pick/orders/${orderNo}/pack/complete`,
  CANCEL_PACK: (orderNo: string) => `/api/admin/pack-pick/orders/${orderNo}/pack/cancel`,
  GET_PACKED_ORDERS: '/api/admin/pack-pick/packed-orders',
  GET_PACKED_ORDER_HISTORY: (orderNo: string) => `/api/admin/pack-pick/packed-orders/${orderNo}`,
  GET_PACKED_ORDER_PACKAGES: (orderNo: string) =>
    `/api/admin/pack-pick/packed-orders/${orderNo}/packages`,
};
